import { connsPublic } from '@cfg/axiosConfig.tsx';
import { Banner } from '@eshop/types/banners.types.ts';
import { logInfo } from '@tools/LogsHandler.tsx';

const URL = 'eshop:banners';

export const BannersApi = {
  async list(params: { page: string; category_id?: number | null }): Promise<Banner[]> {
    const { data } = await connsPublic<Banner[]>(URL).get(params);
    logInfo('BannersApi - data', data);
    return data;
  },
};
